import { hearingPhoneNumbersMatch } from './hearingPhoneMatch';

import type {
  CallHearingState,
  HearingParticipant,
  HearingPhone,
} from 'features/call/call-hearing/interfaces';

export interface HearingSelector {
  phoneNumber: HearingPhone;
}

export const findHearingByPhoneNumber = (
  state: CallHearingState,
  selector: HearingSelector
): HearingParticipant => {
  const hearing = state.hearings.find(({ phoneNumber }: HearingParticipant) =>
    hearingPhoneNumbersMatch(selector.phoneNumber, phoneNumber)
  );

  if (!hearing) {
    throw new Error(`Hearing (${selector.phoneNumber}) not found`);
  }
  return hearing;
};

export const findLatestHearingByPhoneNumber = (
  hearings: HearingParticipant[],
  phoneNumber: string
): HearingParticipant | undefined => {
  if (!phoneNumber) {
    return undefined;
  }

  return [...hearings]
    .reverse()
    .find((hearing) =>
      hearingPhoneNumbersMatch(hearing.phoneNumber, phoneNumber)
    );
};

export const findPrimaryHearing = (
  state: CallHearingState
): HearingParticipant =>
  state.hearings.find(({ type }: HearingParticipant) => type === 'PRIMARY')!;

export const findVCO2Line = (state: CallHearingState): HearingParticipant =>
  state.hearings.find(({ type }: HearingParticipant) => type === 'VCO2LINE')!;

export const findHearingById = (
  state: CallHearingState,
  hearingId: string
): HearingParticipant => {
  const hearing = state.hearings.find(
    ({ id }: HearingParticipant) => id === hearingId
  );

  if (!hearing) {
    throw new Error(`Hearing (${hearingId}) not found`);
  }
  return hearing;
};
